export default (title) => {
  const parts = title.split('/')
    .map((part) => part.trim());

  return parts[parts.length - 1];
};
